window.$catalog_measures_result = [];
window.$catalog_measures_treeChangeStatus = false;
window.$catalog_measures_page_number = 1;
window.$catalog_measures_Glist = [];
window.$catalog_measures_selectedRow = [];
window.$catalog_measures_content = [];
window.$catalog_measures_sliderImages = [];
window.$catalog_measures_context = null;
window.$catalog_measures_refresh = function(){};
window.$catalog_measures_actions = [
  {
    id: "24c25633-b904-4723-a7fb-693d11b8c293",
    text: "(De-)activeer maatregel",
    class: "locate",
    modal: "de_activeer_maatregel",
  },
  {
    id: "ac2c02c3-b545-42df-88dd-16abc83c01fc",
    text: "Koppelen discipline",
    class: "locate",
    modal: "koppelen_discipline",
  },
  {
    id: "4b2b5976-21e5-4810-8f58-adf0e8ecf481",
    text: "Koppelen grootboek",
    class: "locate",
    modal: "grootboek",
  },
  {
    id: "290bc8a2-164d-4c73-8a01-4b9431cd6bea",
    text: "Plaats in map",
    class: "locate",
    modal: "modal_koppel_aan_folder",
  },
  {
    id: "0b9704cf-9838-4361-b79b-5e81a5337114",
    text: "Bewerk prijs per uitvoerder",
    class: "locate",
    modal: "bewerk_prijs_per_uitvoerder",
  },
  {
    id: "16514ed7-9d02-47ec-bc93-6cf6b15225b4",
    text: "Koppelen werkbron",
    class: "locate",
    modal: "koppelen_werkbron",
  },
];
window.$catalog_measures_actions_identifications = [];

window.$catalog_measures_algemeenCode = [];
window.$catalog_measures_algemeenNaam = [];
window.$catalog_measures_algemeenBestekspost = [];
window.$catalog_measures_algemeenKwaliteit = [];
window.$catalog_measures_algemeenOmschrijving = [];

window.$catalog_measures_scroll_change = false;
window.$catalog_measures_last_used_table_filter = {
  content: [],
  definitions: [],
};
window.$catalog_measures_selected_ids = null;
window.$catalog_measures_column_list = null;
window.$catalog_measures_column_table_total_row_count = 0;
window.$catalog_measures_column_columnListPure = null;
window.$catalog_measures_grootboek_nummer = {
  id: null,
  text: null,
  definitions: null,
};
window.$catalog_measures_discipline = {
  id: null,
  text: null,
  definitions: null,
};
window.$catalog_measures_newInsertId = [];
window.$catalog_measures_column_order_post_model = {
  client_identification: "",
  code: "",
  data: {
    table_sorting: [
      {
        name: "catalog>measures",
        column_list: [
          "checkbox",
          "active",
          "Naam",
          "Code",
          "Bestekspost",
          "paperclip",
          "RAW Hoofdcode",
          "RAW Deficode",
          "Grootboekrekening",
          "Eenheidsprijs",
          "Eenheid",
          "Percentage",
          "Kwaliteit",
          "Omschrijving",
          "Periode voorkeur",
          "Patroon voorkeur",
        ],
      },
    ],
  },
};
